var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRouter } from 'next/router';
import { giveawayAnalyticsEvents, VerifySteamStage, } from 'root/src/shared/giveaways/giveaways.constants';
import { useEffect } from 'react';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { useUserId } from 'root/src/client/v2/auth/hooks/useUserId';
export const useVerifySteamModal = () => {
    const router = useRouter();
    const { userId } = useUserId();
    const { stage = VerifySteamStage.SIGN_IN, track = 'false', } = router.query;
    const setStage = (newStage) => {
        void router.replace({
            query: Object.assign(Object.assign({}, router.query), { stage: newStage }),
        });
    };
    const trackEvent = () => __awaiter(void 0, void 0, void 0, function* () {
        if (stage === VerifySteamStage.SUCCESS) {
            yield router.replace({
                query: Object.assign(Object.assign({}, router.query), { track: false }),
            });
            analyticsSendItem(giveawayAnalyticsEvents.SUBMIT_STEAM_ENTRY_SUCCESS, userId);
        }
    });
    useEffect(() => {
        if (JSON.parse(track)) {
            trackEvent();
        }
    }, []);
    return {
        stage,
        setStage,
    };
};
